module.exports = __webpack_public_path__ + "img/eur.53410ca2.svg";